import { Grid, IconButton, Chip, Divider } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    padding: theme.spacing(2.5, 2.5, 0, 0),
  },
  card: {
    padding: theme.spacing(2.5),
    borderRadius: 10,
    backgroundColor: '#FFF',
    width: '100%',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
    },
  },
  infoCandidat: {
    display: 'flex',
    alignItems: 'start',
    width: '100%',
  },
  avatar: {
    width: 56,
    height: 56,
    borderRadius: '50%',
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: 40,
      height: 40,
      marginRight: theme.spacing(1),
    },
  },
  menuBtn: {
    margin: '0px 3px',
    alignSelf: 'baseline',
    borderRadius: '20px',
    border: '1px solid #C0D9FF',
    backgroundColor: '#F3F7FF',
    width: 26,
    height: 26,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  infoBlock: {
    marginLeft: theme.spacing(1.5),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '70%',
  },
  divStudent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  },
  line: {
    marginBottom: 8,
    width: '80%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 6,
    },
  },
  icon: {
    width: 20,
    height: 20,
    marginRight: theme.spacing(1),
    display: 'inline-block',
  },
  chip: {
    borderRadius: 10,
    height: 32,
    marginTop: theme.spacing(1),
    width: '60%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  skeletonColor: {
    backgroundColor: '#D6E7FF !important',
    '&::after': {
      background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)',
    }
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
}));

const CandidatsCardSkeleton = () => {
  const classes = useStyles();
  return (
    <Grid item className={classes.container}>
      <div className={classes.card}>
        <div className={classes.infoCandidat}>
          <Skeleton variant="circle" width={56} height={56} className={classes.avatar + ' ' + classes.skeletonColor} />
          <div className={classes.infoBlock}>
            <div className={classes.divStudent}>
              <Skeleton variant="text" width="40%" height={24} className={classes.skeletonColor} />
              {/* <IconButton className={classes.menuBtn} size="small">
                <Skeleton variant="circle" width={15} height={15} className={classes.skeletonColor} />
              </IconButton> */}
            </div>
            <Skeleton variant="text" width="30%" height={18} className={classes.skeletonColor} />
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', margin: '8px 0 0 0' }}>
          <Skeleton variant="circle" width={20} height={20} className={classes.skeletonColor} />
          <Skeleton variant="text" width="30%" height={18} className={classes.skeletonColor} style={{ marginLeft: 16 }} />
        </div>
        <Divider className={classes.divider} />
        {[1, 2, 3, 4, 5, 6, 7].map((i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
            <Skeleton variant="rect" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
            <Skeleton variant="text" width="40%" height={18} className={classes.skeletonColor} />
          </div>
        ))}
        <Divider className={classes.divider} />
        <Skeleton variant="rect" width="60%" height={32} className={classes.skeletonColor + ' ' + classes.chip} />
      </div>
    </Grid>
  );
};

export default CandidatsCardSkeleton; 